import { render, staticRenderFns } from "./LogWrapper.vue?vue&type=template&id=2940899a&scoped=true&"
import script from "./LogWrapper.vue?vue&type=script&lang=js&"
export * from "./LogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LogWrapper.vue?vue&type=style&index=0&id=2940899a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940899a",
  null
  
)

export default component.exports